import IconTemplate from '@/components/icons/IconTemplate.vue';

import RadioOff from '@/assets/ui-icons/templates/RadioOff.vue';
import RadioOn from '@/assets/ui-icons/templates/RadioOn.vue';
import NotificationActive from '@/assets/ui-icons/templates/NotificationActive.vue';
import CheckboxOff from '@/assets/ui-icons/templates/CheckboxOff.vue';
import CheckboxOn from '@/assets/ui-icons/templates/CheckboxOn.vue';

const getIconName = (name) => `ui-${name}`;

const getIconFromTemplate = (name, component) => ({
  [getIconName(name)]: {
    component,
  },
});

export default () => {
  const icons = require.context('@/assets/ui-icons', false, /.*\.svg$/);
  return {
    ...Object.fromEntries(icons.keys().map((path) => {
      const name = path.replace('./', '').replace('.svg', '');
      return [
        getIconName(name),
        {
          component: IconTemplate,
          props: {
            name,
          },
        },
      ];
    })),
    ...getIconFromTemplate('checkbox-off', CheckboxOff),
    ...getIconFromTemplate('checkbox-on', CheckboxOn),
    ...getIconFromTemplate('radio-off', RadioOff),
    ...getIconFromTemplate('radio-on', RadioOn),
    ...getIconFromTemplate('notification-active', NotificationActive),
  };
};
